import { Injectable } from '@angular/core';

@Injectable()
export class LocalizationService {

    get languages(): solid.localization.ILanguageInfo[] {
        return solid.localization.languages;
    }

    get currentLanguage(): solid.localization.ILanguageInfo {
        return solid.localization.currentLanguage;
    }

    localize(key: string, sourceName: string): string {
        return solid.localization.localize(key, sourceName);
    }
    
    getSource(sourceName: string): (key: string) => string {
        return solid.localization.getSource(sourceName);
    }

}